import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { ShareIcon } from 'site-modules/shared/components/social-media/share-icon/share-icon';

import './insights-card.scss';

export function InsightsCard({ contentStr = '', imageUrl = '', pageUrl = '', isYellow = false, isBlue = false }) {
  const plainText = contentStr.replace(/(<([^>]+)>)/gi, '');

  return (
    <div
      className={classnames('insights-card d-flex flex-column justify-content-between h-100', {
        'yellow-bg': isYellow && !imageUrl,
        'blue-bg': isBlue && !imageUrl,
      })}
    >
      <div className="p-1_5">
        <ContentFragment classes="card-content">{contentStr}</ContentFragment>
      </div>
      <div className="d-flex justify-content-between align-items-end">
        {imageUrl && <img src={imageUrl} loading="lazy" alt="" className="cover" height={98} />}
        <div className="social ms-auto py-1_5 pe-2">
          {imageUrl && <div className="shape" />}
          <ShareIcon className="social-icon text-primary size-24 p-0" brand="twitter" title={plainText} url={pageUrl} />
        </div>
      </div>
    </div>
  );
}

InsightsCard.propTypes = {
  contentStr: PropTypes.string,
  imageUrl: PropTypes.string,
  pageUrl: PropTypes.string,
  isYellow: PropTypes.bool,
  isBlue: PropTypes.bool,
};
